export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network parameters to kubernetes."])}
      },
      "zh": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["网络参数"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kubernetes 集群的网络参数"])}
      }
    }
  })
}
